module.exports = __webpack_public_path__ + "static/img/09ko.5f0538b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/09ko.jpg
// module id = QYk0
// module chunks = 0